import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;
export const getAllNotifications = async (email, isFranchise, query) => {
  var pageSize = query?.pageSize !== undefined ? query?.pageSize : 10;
  var pageNumber = query?.page !== undefined ? query?.page + 1 : 1;
  return axios.get(
    `${api_base_url}/Notification/GetNotification?email=${email}&isFranchise=${isFranchise}&type=2&PageNumber=${pageNumber}&PageSize=${pageSize}&search=${query.search}`
  );
};
